// extracted by mini-css-extract-plugin
export default {"touchIconButton":"BookUniViniTouch_touchIconButton__L8ScX","touchAudioPlayer":"BookUniViniTouch_touchAudioPlayer__nsWQn"};